import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Typography } from "@mui/material";
import { SimpleForm, SelectInput, ReferenceInput, Create, FormDataConsumer, } from "react-admin";
import { JsonInput } from "react-admin-json-view";
import { usePresentationName } from "../../hooks/usePresentationName";
export var CreateAreaContest = function () {
    var presentationName = usePresentationName();
    return (_jsx(Create, { children: _jsxs(SimpleForm, { children: [_jsx(Typography, { variant: "h4", children: "Area Contest" }), _jsx(Typography, { variant: "body2", children: "Area Contest creation" }), _jsx(ReferenceInput, { source: "tenant_id", reference: "sequent_backend_tenant", children: _jsx(SelectInput, { optionText: "slug" }) }), _jsx(FormDataConsumer, { children: function (_a) {
                        var formData = _a.formData;
                        return (_jsxs(_Fragment, { children: [_jsx(ReferenceInput, { source: "election_event_id", reference: "sequent_backend_election_event", filter: { tenant_id: formData.tenant_id }, children: _jsx(SelectInput, { optionText: presentationName }) }), _jsx(ReferenceInput, { source: "contest_id", reference: "sequent_backend_contest", filter: {
                                        tenant_id: formData.tenant_id,
                                        election_event_id: formData.election_event_id,
                                    }, children: _jsx(SelectInput, { optionText: presentationName }) }), _jsx(ReferenceInput, { source: "area_id", reference: "sequent_backend_area", filter: {
                                        tenant_id: formData.tenant_id,
                                        election_event_id: formData.election_event_id,
                                    }, children: _jsx(SelectInput, { optionText: "name" }) })] }));
                    } }), _jsx(JsonInput, { source: "labels", jsonString: false, reactJsonOptions: {
                        name: null,
                        collapsed: true,
                        enableClipboard: true,
                        displayDataTypes: false,
                    } }), _jsx(JsonInput, { source: "annotations", jsonString: false, reactJsonOptions: {
                        name: null,
                        collapsed: true,
                        enableClipboard: true,
                        displayDataTypes: false,
                    } })] }) }));
};
